"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @trackcomponent */
export const Clover = createSVGIcon(
  <>
    <path
      d="M 11.1952 5.6584 C 11.1952 3.3524 9.8156 1.3924 7.746 0.47 C 5.6764 -0.4524 3.262 0.0088 1.6524 1.6232 C 0.0428 3.2372 -0.4168 5.6584 0.388 7.734 C 1.1928 9.8092 3.262 11.1928 5.5616 11.1928 H 11.1952 V 5.6584 Z M 12.8048 5.6584 C 12.8048 3.3524 14.1844 1.3924 16.254 0.47 C 18.3236 -0.4524 20.738 0.0088 22.3476 1.6232 C 23.9572 3.2372 24.4168 5.6584 23.612 7.734 C 22.8072 9.8092 20.738 11.1928 18.4384 11.1928 H 12.8048 V 5.6584 Z M 12.8048 18.3416 C 12.8048 20.6472 14.1844 22.6076 16.254 23.53 C 18.3236 24.4524 20.738 23.9912 22.3476 22.3768 C 23.9572 20.7628 24.4168 18.3416 23.612 16.266 C 22.8072 14.1908 20.738 12.8072 18.4384 12.8072 H 12.8048 V 18.3416 Z M 5.5616 22.3768 C 7.746 22.3768 9.5856 20.6472 9.5856 18.3416 V 14.306 H 5.5616 C 3.3772 14.306 1.5376 16.0356 1.5376 18.3416 C 1.5376 20.6472 3.3772 22.3768 5.5616 22.3768 Z M 11.1952 18.3416 C 11.1952 20.6472 9.8156 22.6076 7.746 23.53 C 5.6764 24.4524 3.262 23.9912 1.6524 22.3768 C 0.0428 20.7628 -0.4168 18.3416 0.388 16.266 C 1.1928 14.1908 3.262 12.8072 5.5616 12.8072 H 11.1952 V 18.3416 Z"
      fill="#228800"
    />
  </>,
  "Clover",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
